var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenshotsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_875_7789)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3594 19.5741C27.3594 20.4398 26.6576 21.1416 25.7919 21.1416H2.5675C1.70179 21.1416 1 20.4398 1 19.5741V2.5675C1 1.70179 1.70179 1 2.5675 1H25.7919C26.6576 1 27.3594 1.7018 27.3594 2.5675V19.5741Z",
    stroke: "#605BFF",
    strokeWidth: 1.38033,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61719 23.7783H20.7422",
    stroke: "#605BFF",
    strokeWidth: 1.61758,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1797 17.1099C11.2404 16.1332 9.25781 13.3913 9.25781 10.3029V7.2975L14.1797 5.66211L19.1016 7.2975V10.3029C19.1016 13.3913 17.119 16.1332 14.1797 17.1099Z",
    fill: "#605BFF",
    stroke: "#605BFF",
    strokeWidth: 1.38033,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1797 8.32568V10.1567",
    stroke: "white",
    strokeWidth: 1.61758,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3594 13.8188H15",
    stroke: "white",
    strokeWidth: 1.61758,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_875_7789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshotsIcon);
export default __webpack_public_path__ + "static/media/ScreenshotsIcon.c6b5677c94abf5ed126893b827c341ac.svg";
export { ForwardRef as ReactComponent };